import { Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../../Context/AuthProvider";
import { useGetLogout } from "../../../Components/Login/Hooks";
import AcUnitIcon from '@mui/icons-material/AcUnit';
function Item({
  title,
  to,
  icon,
  selected,
  setSelected,
  replace,
  smallpadding,
  sidebar
}) {
    const newOpr = useAuth();
    // logout Handle
    const { mutate, isSuccess } = useGetLogout();



    const clickSetup = async () => {
      setSelected(title);
      if (title === "خروج") {
        newOpr.logout();
        await mutate();
      }
    };
  return (
    <li
      className={`${window.location.pathname===to ? "active" : ""}`}
      disabled={true}
      style={{
        padding: smallpadding ? "0.8rem 0.4rem" : "0.8rem",
        listStyle: "none",
        width: "100%",
      }}
      onClick={clickSetup}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        {icon}
        {sidebar && (
          <Typography
            component={"div"}
            fontFamily="yekan"
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              marginLeft: icon ? "0.5rem" : "0",
            }}
          >
            <Link
              replace
              to={to}
              disabled={true}
              style={{
                textDecoration: "none",
                color: "rgb(238, 238, 238)",
                fontSize: "14px",
              }}
            >
              {title}
            </Link>
          </Typography>
        )}
      </div>
    </li>
  );
}

export default Item;
